import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const newYear2026ToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.NEW_YEAR_2026,
  iFrameSrcUrl: '/members-2026',
  micrositeUrl: 'members',
  title: {
    id: 'newYear2026Toolkit.title',
    defaultMessage: 'A healthier, happier you starts here',
    description: 'Microsite page title',
  },
  featureFlag: 'isNewYear2026ToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WELLNESS_CHECK_IN,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_ESSENTIALS,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events/curious-about-mental-health-support',
      },
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION,
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
  ],
  page: '2026 members',
  trackUTMParams: {
    utm_campaign: '2026members',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'lyra 2026 members',
  },
  shouldHideForInternational: false,
}
